import React, { useState } from 'react';

const ReportTypeSelect = (props) => {

    const [reportType, setReportType] = useState((props.reportType != null) ? props.reportType : 0);


    const handleChange = (e) => {

        setReportType(e.target.value);
        (e.target.value != 12) ?
            props.selectedRepo(e.target.value)
            :
            props.showAllOpen()
    }

    return (
        <select
            className={`${props.onLeft} selectInBlockMobi`}
            value={reportType}
            onChange={handleChange}>

            <option value={5}>ממתינות לאישור</option>
            <option value={6}>להיום ומחר</option>
            <option value={7}>עד סוף השבוע</option>
            <option value={8}>עד סוף החודש</option>
            <option value={12}>פתוחות הכל</option>
            <option value={10}>לפי תאריכים</option>

        </select>
    );
}

export default ReportTypeSelect;